var _style, _path, _g, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainPageCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 524.9 369.8",
    style: {
      enableBackground: "new 0 0 524.9 369.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#4CD9ED;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#56B0FF;}\n\t.st5{fill:#B7F6FF;}\n\t.st6{fill:#95DDFF;}\n\t.st7{fill:#4199FF;}\n\t.st8{fill:#48637C;}\n\t.st9{fill:#73C5FF;}\n\t.st10{fill:#3286ED;}\n\t.st11{opacity:0.5;fill:#587791;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.094947e-13,
    y1: 260.5392,
    x2: 524.9488,
    y2: 260.5392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#437FEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#336DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4923,
    style: {
      stopColor: "#245CBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7557,
    style: {
      stopColor: "#1B51B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#184EAE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.9,155.7c-4.4,77.5-93.9,120.6-160.3,136.5c-61.7,14.7-126.7,15.5-188.9,3C99,281-0.4,229.3,0.2,151.2 L0,217.1C-0.7,291.6,91,343,165.4,358.9c56.8,13,116.3,14.3,173.7,4.4c64.5-11.6,142.1-40.9,174.7-101.6 c5.5-10.8,9.2-22.5,10.4-34.5c0.8-3.4,0.6-69.1,0.6-74.5C524.9,153.7,524.9,154.7,524.9,155.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,46.9c102.8,59.4,103.3,155.6,1.2,214.9c-102.1,59.4-268.3,59.4-371.1,0 C-25.2,202.4-25.7,106.2,76.4,46.9C178.6-12.5,344.7-12.5,447.5,46.9z M100,248.8c90.2,52.1,236.6,52.1,326.3,0 c89.7-52.1,89.2-136.9-1.1-189c-90.2-52.1-236.6-52.1-326.3,0C9.2,111.9,9.7,196.7,100,248.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1905,
    y1: 151.9793,
    x2: 524.9493,
    y2: 151.9793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#1C9BF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5128,
    style: {
      stopColor: "#328CF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    style: {
      stopColor: "#3F82ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#437FEC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M447.5,44.5c102.8,59.4,103.3,155.6,1.2,214.9c-102.1,59.4-268.3,59.4-371.1,0 C-25.2,200.1-25.7,103.9,76.4,44.5C178.6-14.8,344.7-14.8,447.5,44.5z M100,246.5c90.2,52.1,236.6,52.1,326.3,0 c89.7-52.1,89.2-136.9-1.1-189c-90.2-52.1-236.6-52.1-326.3,0C9.2,109.6,9.7,194.4,100,246.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.1805,
    y1: 151.979,
    x2: 31.9484,
    y2: 151.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F4FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M425.2,57.5c90.2,52.1,90.7,136.9,1.1,189c-89.7,52.1-236,52.1-326.3,0c-90.2-52.1-90.8-136.9-1.1-189 C188.5,5.4,334.9,5.4,425.2,57.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "321.8,247.9 278.7,212.8 289.1,148.8 298,94.1 350,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "350,74.3 289.2,148.9 289.1,148.8 298,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "289.2,148.9 321.8,247.9 350,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "256.4,145 185.6,136.7 246.1,113.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "246.1,113.8 185.6,136.7 142.5,101.6 306.9,39.2 298,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "278.7,212.8 185.6,136.7 256.4,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "306.9,39.2 246.1,113.7 142.5,101.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "289.1,148.8 256.4,145 246.1,113.8 298,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "298,94.1 246.1,113.8 246.1,113.7 306.9,39.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "278.7,212.8 256.4,145 289.1,148.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "133.7,156.4 232.2,174.8 256.4,145 185.5,136.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "269.9,267.6 232.2,174.8 256.4,145 278.8,212.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "278.7,212.8 185.5,136.7 256.4,145  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageCoin);
export default __webpack_public_path__ + "static/media/main-page-coin.89a4243ed64e49ad42273024a01f9ec3.svg";
export { ForwardRef as ReactComponent };